import { render } from "./LocationWiseUserCount.vue?vue&type=template&id=321da216&scoped=true"
import script from "./LocationWiseUserCount.vue?vue&type=script&lang=js"
export * from "./LocationWiseUserCount.vue?vue&type=script&lang=js"

import "./LocationWiseUserCount.vue?vue&type=style&index=0&id=321da216&scoped=true&lang=scss"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321da216"]])

export default __exports__